import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TiimeButtonModule, TiimeIconModule, TiimeTooltipModule } from 'tiime-material';

@Component({
  selector: 'app-tag-icon',
  standalone: true,
  imports: [TiimeIconModule, TiimeButtonModule, TiimeTooltipModule],
  templateUrl: './tag-icon.component.html',
  styleUrl: './tag-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'tiime-icon-container' }
})
export class TagIconComponent {
  tags = input.required<unknown[]>();
}
